/*eslint-env node*/
const { linkResolver } = require('./link-resolver');
const HtmlSerializer = require('./html-serializer');

module.exports = {
  linkResolver,
  htmlSerializer: HtmlSerializer
};
